import { render, staticRenderFns } from "./ReclameAquiAverageMonthlyComplaints.vue?vue&type=template&id=1721fda7&"
import script from "./ReclameAquiAverageMonthlyComplaints.vue?vue&type=script&lang=ts&"
export * from "./ReclameAquiAverageMonthlyComplaints.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports